<template>
  <div class="page2">
    <div class="mk2">
      <div class="body">
        <div class="block mk1">
          <!-- <div class="header-title">
            <div class="bty only-one_1">黄色背景：症状对应唯一的辨证</div>
            <div class="bty only-one_2">
              绿色背景：串联链路中症状对应的非唯一辨证
            </div>
            <div class="bty only-one_3">
              蓝色背景：单独线路中内因或外因导致的辨证
            </div>
          </div> -->
          <div class="table-block" id="part1">
            <Table
              border
              class="table_right"
              :columns="columns3"
              :data="list"
              :cellClassName="cellClassName2"
            ></Table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  watch: {},
  data() {
    return {
      columns3: [
        {
          title: "木",
          key: "木",
          minWidth: 120,
        },
        {
          title: "火",
          key: "火",
          minWidth: 120,
        },
        {
          title: "土",
          key: "土",
          minWidth: 120,
        },
        {
          title: "金",
          key: "金",
          minWidth: 120,
        },
        {
          title: "水",
          key: "水",
          minWidth: 120,
        },
      ],
    };
  },
  methods: {
    // tablei2单元格添加颜色
    cellClassName2({ row, column, rowIndex, columnIndex }) {
      return "only-one_" + row[column.label + "onlyOne"];
    },
  },
  mounted() {
    // this.init();
  },
};
</script>
  
<style scoped lang="scss">
.page2 {
  line-height: 1.5em;
  :deep {
    .ivu-table-cell {
      padding: 0 10px;
      line-height: 26px;
    }
  }
  .mk1 {
    margin-bottom: 15px;
    .header {
      margin-bottom: 15px;
    }
  }
  .mk2 {
    height: 100%;
    overflow-y: auto;
  }

  .table-header {
    display: flex;
    justify-content: space-between;

    .label {
      font-weight: bold;
    }

    .other {
      font-size: 12px;
      opacity: 0.6;
    }
  }

  .body {
    height: 100%;
    .header-title {
      margin-bottom: 15px;
      line-height: 20px;
      & > div {
        display: inline-block;
        margin: 0 10px 10px 0;
        padding: 3px 15px;
      }
    }
    .table-block {
      height: 100%;
      width: 100%;
      overflow-y: auto;
      position: relative;
      display: flex;
      padding-bottom: 20px;
      .table_left {
        width: 1150px;
        flex-shrink: 0;
      }
      .table_right {
        width: 100%;
        margin-bottom: 15px;
      }
    }
  }

  :deep {
    .only-one_1 {
      background: #fac006 !important;
      color: #000;
    }
    .only-one_2 {
      background: #91ce51 !important;
      color: #000;
    }
    .only-one_3 {
      background: #02aeef !important;
      color: #000;
    }
  }
}
</style>
  